import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { actionCreators, selectors } from '../../store/modules/User';

class UserPassword extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
    this.state = {
      passwordChange: false,
      confirmation: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { passwordChange } = this.state;

    if (nextProps.passwordChange && passwordChange === nextProps.passwordChange) {
      this.setState({ confirmation: true });
    }
  }

  handleSave(values) {
    const {
      requestChangePassword,
      requestForgotPassword,
      requestChangePasswordConfirmation,
      requestForgotPasswordConfirmation,
      isAuthenticated,
    } = this.props;
    const { confirmation } = this.state;

    const newPasswordChange = { ...values };

    if (confirmation) {
      if (isAuthenticated) {
        requestChangePasswordConfirmation(newPasswordChange);
      } else {
        requestForgotPasswordConfirmation(newPasswordChange);
      }
    } else {
      if (isAuthenticated) {
        requestChangePassword(newPasswordChange);
      } else {
        requestForgotPassword(newPasswordChange);
      }
      this.setState({ passwordChange: newPasswordChange });
    }
  }

  render() {
    const { confirmation } = this.state;
    const { isAuthenticated } = this.props;

    return (
      <Formik onSubmit={values => this.handleSave(values)}
        ref={this.form}
        enableReinitialize
        validationSchema={Yup.object().shape({
          email: isAuthenticated
            ? Yup.string().nullable()
            : Yup.string()
              .email()
              .min(5)
              .max(254)
              .required(),
          password: isAuthenticated
            ? Yup.string()
              .min(6)
              .max(100)
              .required()
            : Yup.string().nullable(),
          newPassword: isAuthenticated
            ? Yup.string()
              .min(6)
              .max(100)
              .required()
            : Yup.string().nullable(),
          code: confirmation ? Yup.string().required() : Yup.string().nullable(),
        })}
        initialValues={{
          email: '',
          password: '',
          newPassword: '',
          code: '',
        }}
        render={({ errors }) => (
          <Form>
            <div id="dataForm">
              <div className="row m-b-sm">
                <div className="col-sm-12">
                  <span className="page-title no-image">{isAuthenticated ? 'Paroles Maiņa' : 'Aizmirsta Parole'}</span>
                </div>
              </div>
              <div className="row p-l-md">
                <div className="col-md-12">
                  <div className="panel panel-default">
                    <div className="panel-heading" />
                    <div className="panel-body" id="scroller">
                      <div className="col-md-9">
                        {!confirmation
                          && !isAuthenticated && (
                            <div className="row">
                              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div className="form-group form-group-lg label-static is-empty">
                                  <label htmlFor="email" className="control-label font-bold">
                                    Epasts
                                    <Field id="email"
                                      name="email"
                                      type="email"
                                      autoFocus
                                      autoComplete="off"
                                      className={errors.email ? 'form-control error' : 'form-control'} />
                                  </label>
                                </div>
                              </div>
                            </div>
                        )}
                        {!confirmation
                          && isAuthenticated && (
                            <React.Fragment>
                              <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                  <div className="form-group form-group-lg label-static is-empty">
                                    <label htmlFor="password" className="control-label font-bold">
                                      Esošā parole
                                      <Field id="password"
                                        name="password"
                                        type="password"
                                        autoFocus
                                        autoComplete="off"
                                        className={errors.password ? 'form-control error' : 'form-control'} />
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                  <div className="form-group form-group-lg label-static is-empty">
                                    <label htmlFor="newPassword" className="control-label font-bold">
                                      Jaunā parole
                                      <Field id="newPassword"
                                        name="newPassword"
                                        type="password"
                                        autoComplete="off"
                                        className={errors.newPassword ? 'form-control error' : 'form-control'} />
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </React.Fragment>
                        )}
                        {confirmation && (
                          <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                              <div className="form-group form-group-lg label-static is-empty">
                                <label htmlFor="code" className="control-label font-bold">
                                  SMS kods
                                  <Field id="code"
                                    name="code"
                                    autoFocus
                                    autoComplete="off"
                                    className={errors.code ? 'form-control error' : 'form-control'} />
                                </label>
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="row">
                          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <button type="submit" className="gaas-tile-btn">
                              {confirmation ? 'Apstiprināt' : 'Atjaunot'}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )} />
    );
  }
}

UserPassword.propTypes = {
  requestChangePassword: PropTypes.func.isRequired,
  requestForgotPassword: PropTypes.func.isRequired,
  requestChangePasswordConfirmation: PropTypes.func.isRequired,
  requestForgotPasswordConfirmation: PropTypes.func.isRequired,
  passwordChange: PropTypes.shape({}).isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

export default connect(
  state => ({
    passwordChange: state.user.passwordChange,
    isAuthenticated: selectors.getIsAuthenticated(state),
  }),
  dispatch => bindActionCreators(actionCreators, dispatch),
)(UserPassword);



// WEBPACK FOOTER //
// ./src/components/user/Password.jsx